import { environmentManager, QueryClient } from '@tanstack/react-query'
import { cache } from 'react'

// Browser cache retains for 12h, server clients live only as long as the request
const GC_TIME_BROWSER = 1000 * 60 * 60 * 12

const makeClient = (gcTime: number) =>
  new QueryClient({
    defaultOptions: {
      queries: {
        gcTime,
        refetchOnWindowFocus: false,
        retry: false,
        retryOnMount: false,
        staleTime: Infinity,
      },
    },
  })

// cache() scopes one client to a single server request
const getServerClient = cache(() => makeClient(Infinity))

let browserClient: QueryClient | null = null

export const getQueryClient = () => {
  if (environmentManager.isServer()) return getServerClient()

  browserClient ??= makeClient(GC_TIME_BROWSER)

  return browserClient
}
